import { LoginView, LoginViewModel } from "../../viewmodels/LoginViewModel.js";
import { LoginWrapper } from "./Wrapper.js";
import { LoginForm } from "./views/LoginForm.js";
import { PickUser } from "./views/PickUser.js";
import { PasswordReset } from "./views/PasswordReset.js";
import { ResetRequested } from "./views/ResetRequested.js";
import { NewPassword } from "./views/NewPassword.js";
import { NewPasswordSuccess } from "./views/NewPasswordSuccess.js";
import { LegacyUser } from "./views/LegacyUser.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { useLocal } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/components/Login/Login.tsx
function Login() {
	const vm = useLocal(() => new LoginViewModel(LoginViewModel.DEFAULT_STATE));
	const renderView = () => {
		switch (vm.state.activeView) {
			case LoginView.PickUser: return /* @__PURE__ */ jsx(PickUser, {
				error: vm.state.error || void 0,
				loading: vm.async.handleLoginAsUser.loading,
				onCancel: () => vm.backToLoginForm(),
				onPickUser: vm.handleLoginAsUser,
				users: vm.state.users ?? []
			});
			case LoginView.PasswordReset: return /* @__PURE__ */ jsx(PasswordReset, {
				email: vm.state.resetEmail,
				error: vm.state.error || void 0,
				loading: vm.async.requestPasswordReset.loading,
				onCancel: () => vm.backToLoginForm(),
				onChangeEmail: vm.setResetEmail,
				onSubmit: vm.requestPasswordReset
			});
			case LoginView.ResetRequested: return /* @__PURE__ */ jsx(ResetRequested, { onBack: vm.showLoginFormWithResetNote });
			case LoginView.NewPassword: return vm.state.resetToken ? /* @__PURE__ */ jsx(NewPassword, {
				error: vm.state.error || void 0,
				loading: vm.async.setNewPassword.loading,
				onCancel: () => vm.backToLoginForm(),
				onSubmit: vm.setNewPassword
			}) : null;
			case LoginView.NewPasswordSuccess: return /* @__PURE__ */ jsx(NewPasswordSuccess, { onDone: vm.completeNewPasswordFlow });
			case LoginView.LegacyUser: return /* @__PURE__ */ jsx(LegacyUser, { onBack: vm.showLoginForm });
			default: return /* @__PURE__ */ jsx(LoginForm, {
				error: vm.state.error || void 0,
				loading: vm.async.handleLogin.loading,
				onForgotPassword: vm.showPasswordReset,
				onLogin: vm.handleLogin,
				resetRequested: vm.state.resetRequested
			});
		}
	};
	return /* @__PURE__ */ jsx(LoginWrapper, { children: renderView() });
}
//#endregion
export { Login };

//# sourceMappingURL=Login.js.map